// PosReprintSheet.tsx — Feuille « Réimpressions » (parité PosReprintCenter)
// À déposer dans : src/gestion-pos/PosReprintSheet.tsx
// Reproduit la maquette : recherche, filtre de période (Aujourd'hui / 7 j / 30 j),
// statut de paiement, montant « Reste », et 3 actions par ticket (Réimprimer / PDF /
// Encaisser le reste). Alimentée par props — branche-la sur les mêmes endpoints que
// ton PosReprintCenter, ou réutilise PosReprintCenter directement (cf. README).
import React, { useState } from "react";
import { Icon, fmt, TICKET_STATUS_META, PosTicket } from "./posMobileShared";

export type ReprintPeriod = "today" | "7d" | "30d";
const PERIODS: { id: ReprintPeriod; label: string }[] = [
  { id: "today", label: "Aujourd'hui" },
  { id: "7d", label: "7 jours" },
  { id: "30d", label: "30 jours" },
];

export interface PosReprintSheetProps {
  onClose: () => void;
  tickets: PosTicket[];
  period?: ReprintPeriod;
  onPeriodChange?: (p: ReprintPeriod) => void;
  onSearch?: (term: string) => void;
  onReprint?: (t: PosTicket) => void;
  onDownloadPdf?: (t: PosTicket) => void;
  onAddPayment?: (t: PosTicket) => void;
}

export default function PosReprintSheet(props: PosReprintSheetProps) {
  const { onClose, tickets, period, onPeriodChange, onSearch, onReprint, onDownloadPdf, onAddPayment } = props;
  const [localPeriod, setLocalPeriod] = useState<ReprintPeriod>(period ?? "today");
  const active = period ?? localPeriod;
  const setPeriod = (p: ReprintPeriod) => { setLocalPeriod(p); onPeriodChange && onPeriodChange(p); };

  return (
    <>
      <div className="pos-scrim" onClick={onClose} />
      <div className="pos-sheet">
        <div className="pos-grab" />
        <div className="pos-sheet-head">
          <div className="pos-sheet-title">Réimpressions<span className="n">{tickets.length} tickets</span></div>
          <button className="pos-sheet-close" onClick={onClose}><Icon name="x" size={18} stroke={2.2} /></button>
        </div>
        <div className="pos-sheet-body" style={{ paddingBottom: 26 }}>
          <div className="pos-m-search" style={{ marginBottom: 12, background: "var(--rf-card)" }}>
            <Icon name="search" size={19} stroke={2} />
            <input placeholder="N° facture, client, montant…"
              onChange={(e) => onSearch && onSearch(e.target.value)} />
          </div>
          <div className="pos-seg">
            {PERIODS.map((p) => (
              <button key={p.id} className={"pos-seg-btn" + (active === p.id ? " is-active" : "")}
                onClick={() => setPeriod(p.id)}>{p.label}</button>
            ))}
          </div>
          {tickets.length === 0 ? (
            <div className="pos-empty">
              <div className="pos-empty-ico"><Icon name="printer" size={30} stroke={1.6} /></div>
              <div className="pos-empty-t">Aucun ticket</div>
              <div className="pos-empty-s">Aucune vente sur cette période.</div>
            </div>
          ) : tickets.map((t) => {
            const st = TICKET_STATUS_META[t.status];
            const reste = t.total - t.paid;
            return (
              <div className="pos-rtc" key={t.ref}>
                <div className="pos-rtc-top">
                  <div className="pos-rtc-id">
                    <span className="pos-rt-ref">{t.ref}</span>
                    {st && <span className={"rf-pill rf-pill-sm " + st.cls}><span className="rf-pill-dot" />{st.label}</span>}
                  </div>
                  <div className="pos-rt-total">{fmt(t.total)} F</div>
                </div>
                <div className="pos-rt-meta">
                  <Icon name="clock" size={12} stroke={2} />{t.time}<span className="sep">·</span>{t.client}<span className="sep">·</span>{t.mode}
                  {reste > 0 && <span className="pos-rtc-reste">Reste {fmt(reste)} F</span>}
                </div>
                <div className="pos-rtc-actions">
                  <button className="pos-rt-btn" onClick={() => onReprint && onReprint(t)}>
                    <Icon name="printer" size={16} stroke={1.9} />Réimprimer
                  </button>
                  <button className="pos-rtc-ico" aria-label="Télécharger le PDF" onClick={() => onDownloadPdf && onDownloadPdf(t)}>
                    <Icon name="file" size={16} stroke={1.9} />
                  </button>
                  {reste > 0 && (
                    <button className="pos-rtc-pay" onClick={() => onAddPayment && onAddPayment(t)}>
                      <Icon name="banknote" size={16} stroke={1.9} />Encaisser
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
